<div class="flex">
    <div class="w-full min-h-full">
        <ng-content />
    </div>
</div>